export default __webpack_public_path__ + "static/media/shareen.cee428e2.jpeg";